import React from 'react';

const Terms = () => {
  return (
    <div className="bg-[#121212] text-white min-h-screen py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-[#FFC107] mb-8">Termos de Serviço</h1>
        
        <div className="prose prose-invert max-w-none text-gray-300 leading-relaxed space-y-6">
          <p>Última atualização: Janeiro de 2026</p>
          
          <section>
            <h2 className="text-2xl font-semibold text-[#007BFF] mb-4">1. Aceite dos Termos</h2>
            <p>
              Ao acessar este site, você concorda em cumprir estes termos de serviço e todas as leis 
              e regulamentos aplicáveis. O conteúdo deste site é destinado a fins informativos sobre 
              serviços de análise de dados e consultoria.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#007BFF] mb-4">2. Propriedade Intelectual</h2>
            <p>
              Todo o conteúdo visual, códigos de modelos de dashboards e textos presentes neste 
              portfólio são de propriedade exclusiva minha, salvo indicação em contrário. É proibida 
              a reprodução total ou parcial para fins comerciais sem autorização prévia.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#007BFF] mb-4">3. Limitação de Responsabilidade</h2>
            <p>
              Embora eu busque a máxima precisão nas análises, as informações e modelos aqui expostos 
              servem como demonstração de competência técnica. Resultados passados não garantem 
              resultados futuros em cenários de negócios distintos.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#007BFF] mb-4">4. Links Externos</h2>
            <p>
              Este site pode conter links para ferramentas externas (como Google Drive ou WhatsApp). 
              Não me responsabilizo pelas políticas de privacidade ou conteúdos de sites de terceiros.
            </p>
          </section>
        </div>
        
        <div className="mt-12">
          <a href="/" className="text-[#FFC107] hover:underline">← Voltar para o Início</a>
        </div>
      </div>
    </div>
  );
};

export default Terms;